<template>
  <div class="wrap">
    <div class="list">
      <VTree
        ref='tree_devices'
        :multiple="true"
        @node-expand='nodeexpand'
        @node-check='nodechecked'
        :data='groupTree'
        :tpl='tpl'
        :scoped='true'
      />
    </div>

    <div class="selected">
      <div class="selected_groups">
        <p class="center">
           Groups
          {{ notification.groups.length > 0 ? '(' + notification.groups.length + ')' : ''}}
        </p>
        <span
          v-for="(group, group_key) in notification.groups"
          :key="group_key"
          class="selected_groups__item"
        >
          {{group.name}}
          <span @click="delete_group(group_key)" class="mdi mdi-close-box" />
        </span>
      </div>

      <div class="selected_devices">
        <p class="center">
          Devices
          {{ notification.devices.length > 0 ? '(' + notification.devices.length + ')'  : ''}}
        </p>
        <span
          v-for="(device, device_key) in notification.devices"
          :key="device_key"
          class="selected_devices__item"
        >
          <span v-html="device.name"></span>
          <span @click="delete_device(device_key)" class="mdi mdi-close-box" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DeviceList',
  components: {
  },
  data () {
    return {
      devices_list: []
    }
  },
  props: ['notification', 'list_devices'],
  computed: {
    groupTree () {
      return  [{
        expanded: true,
        id: -1,
        label: 'all group',
        name: 'all group',
        children : this.devices_list
      }]
    }
  },

  watch: {
  },
  mounted () {
    this.get_groups()
  },
  methods: {
    delete_in(parent, item){
      if (parent.id === item.id && parent.role === item.role) {
        parent.checked = false
      }else if (parent.children) {
        for (let child of parent.children) {
          this.delete_in(child, item)
        }
      }
    },

    delete_group(index){
      let groups = this.notification.groups
      this.delete_in(this.groupTree[0], groups[index])

      groups.splice(index, 1)
      this.notification.groups = groups
    },

    delete_device(index){
      let devices = this.notification.devices
      this.delete_in(this.groupTree[0], devices[index])

      devices.splice(index, 1)
      this.notification.devices = devices
    },

    nodechecked (node, check) {
      let groups = this.notification.groups
      let devices = this.notification.devices
      let index = 0

      if (check === true) {
        if (node.role === 'group') {
          node.checked = true
          groups.push(node)
          for (let i in node.children) {
            if (node.children[i].role === 'children') {
              index = devices.indexOf(node.children[i])
              if (index > -1) {
                devices.splice(index, 1)
              }
            }else{
              index = groups.indexOf(node.children[i])
              if (index > -1) {
                groups.splice(index, 1)
              }
            }
          }

          for (let i in node.children) {
            node.children[i].checked = true
          }

        }else if (node.role === 'children') {
          devices.push(node)
        }
      }else{

        if (node.role === 'group') {
          for (let i in node.children) {
            node.children[i].checked = false
          }

          for (let gr in groups) {
            if (groups[gr].id === node.id) {
              groups.splice(gr, 1)
            }
          }

        }else if (node.role === 'children') {

          for (let dev in devices) {
            if (devices[dev].id === node.id) {
              devices.splice(dev, 1)
            }
          }

          for (let gr in groups) {
            if (groups[gr].id === node.group_id) {
              for (let child of groups[gr].children) {
                if (child.role !== 'empty' && node.id !== child.id) {
                  child.checked = true
                  if (child.role === 'children') {
                    devices.push(child)
                  }else{
                    groups.push(child)
                  }
                }
              }
              groups.splice(gr, 1)
            }
          }
        }
      }

      this.notification.devices = devices
      this.notification.groups = groups

      if (this.notification.devices.length === 1 && this.notification.groups.length < 1) {
        this.notification.valid_for = 'device'
      } else {
        this.notification.valid_for = 'group'
      }

      this.$emit("devices", this.devices_list)
    },

    nodeexpand(node){
      if (node.role === 'group') {
        if (node.children.length === 1) {
          this.$http.v1.getListDevicesByIdGroup({group_id: node.id}, (response) => {
            let devices = response.data
            for(let j in devices) {
              let device = {
                name: '(' + devices[j].fid + ') ' + '<b>' + devices[j].name2 + '</b>',
                id: devices[j].device_id,
                role: 'children',
                group_id: +node.id,
                checked: node.checked,
                fid: devices[j].fid
              }
              node.children.push(device)
            }
          })
        }
      }
    },

    check_group(parent, group, id){
      parent.children[id] = {
        id: +group.id,
        expanded: false,
        hasExpanded: true,
        parent: group.parent,
        name: group.name,
        children: [],
        role: 'group',
        checked: false
      }

      if (group.children) {
        for(let children_id in group.children) {
          this.check_group(parent.children[id], group.children[children_id], children_id);
        }
      }else{
        parent.children[id].children.push({ role: 'empty', visible: false })
      }

    },

    get_groups () {
      if (this.list_devices.length < 1){
        let groups = this.$store.getters.getDeviceGroupsTree

        let group_list = {children: []}
        for(let group_id in groups) {
          this.check_group(group_list, groups[group_id], group_id);
        }

        this.devices_list = group_list.children
      }else{
        this.devices_list = this.list_devices
      }
    },

    tpl (...args) {
      let {0: node} = args
      let titleClass = node.selected ? 'node-title' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return <span>
        <span class={titleClass} domPropsInnerHTML={node.name} onClick={() => {
          if (node.role === 'group') {
            this.nodeexpand(node)
            node.expanded = !node.expanded
          }else if (node.role === 'children') {
            node.checked = !node.checked
            this.nodechecked(node, node.checked)
          }
         }}></span>
      </span>
    }
  }
}
</script>

<style scoped lang="scss">
.wrap{
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  .list{
    overflow-y: scroll;
    height: 100%;
    width: 60%;
    &::-webkit-scrollbar {
      width: 10px;
    }
    .halo-tree{
      margin-top: 10px;
      margin-left: 20px;
      .inputCheck:after{
        color: black;
      }
      .node-title{
        color: #363636;
        font-weight: 400;
        b{
          font-weight: 800;
        }
      }

    }
  }
  .selected{
    height: 100%;
    width: 40%;
    display: flex;
    flex-direction: column;

    &_groups{
      width: 100%;
      height: 50%;
      padding: 5px;
      border-bottom: 1px solid #efe9e9;
      overflow-x: hidden;
      overflow-y: scroll;
      .center{
        text-align: center;
      }
      &__item {
        display: inline-block;
        background: #fff;
        border: 1px solid #ddd;
        padding: 1px 4px;
        border-radius: 5px;
        margin: 3px;
      }
    }
    &_devices{
      width: 100%;
      height: 50%;
      padding: 5px;
      overflow-x: hidden;
      overflow-y: scroll;
      .center{
        text-align: center;
      }
      &__item {
        display: inline-block;
        background: #fff;
        border: 1px solid #ddd;
        padding: 1px 4px;
        border-radius: 5px;
        margin: 3px;
      }
    }
  }
}



</style>
